module.exports = __webpack_public_path__ + "img/heart-half.06cf420f.svg";